import {
    BUILDING_SET_VALUE,
    CITY_SET_VALUE,
    FIRST_NAME_SET_VALUE,
    EMAIL_SET_VALUE,
    KRA_PIN_NUMBER_SET_VALUE,
    MOBILE_NUMBER_SET_VALUE,
    PO_BOX_SET_VALUE,
    POSTAL_CODE_SET_VALUE,
    setBuildingValid,
    setCityValid,
    setFirstNameValid,
    setEmailValid,
    setKraPinNumberValid,
    setMobileNumberValid,
    setPostalBoxValid,
    setPostalCodeValid,
    setStreetAddressValid,
    STREET_ADDRESS_SET_VALUE,
    SURNAME_SET_VALUE,
    setSurnameValid,
    DOB_SET_VALUE,
    setDobValid,
    ID_PASSPORT_SET_VALUE,
    setIdPassportValid,
    REFERRED_SET_VALUE,
    setReferredValid,
} from '../../../actions/doctorsPi/personalDetails';
import { validationIsEqual } from '../status';
import {
    validateEmail,
    validateFirstName,
    validateSurname,
    validateContactNumber,
    validateAlphaNumericString,
    validateKraPinNumber,
    validatePostalCode,
    validatePoBoxNumber,
    validateDateOfBirth,
    validateName,
    validateIdNumber,
    validateNumericString,
    validatePassportNumber,
    validateSingleSelection,
    validateCellphoneNumber,
} from '@om/validation';

let prevValidationAction = null;
export const personalDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case FIRST_NAME_SET_VALUE:
                error = validateFirstName(action.value, {
                    subject: 'First Name',
                    required: true,
                });
                return setFirstNameValid(error);
            case SURNAME_SET_VALUE:
                error = validateSurname(action.value, {
                    subject: 'Surname',
                    required: true,
                });
                return setSurnameValid(error);
            case DOB_SET_VALUE:
                error = validateDateOfBirth(action.value, {
                    subject: 'Date of Birth',
                    required: true,
                    min: 18,
                });
                return setDobValid(error);

            case KRA_PIN_NUMBER_SET_VALUE:
                error = validateKraPinNumber(action.value, { subject: 'KRA Pin Number' });
                return setKraPinNumberValid(error);

            case MOBILE_NUMBER_SET_VALUE:
                error = validateCellphoneNumber(action.value, {
                    subject: 'Mobile Number',
                    required: true,
                    min: 10,
                    countryCode: 'ke',
                });
                return setMobileNumberValid(error);

            case ID_PASSPORT_SET_VALUE:
                error = validatePassportNumber(action.value, { min: 8, max: 15, required: true });
                return setIdPassportValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case CITY_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'City',
                    required: true,
                });
                return setCityValid(error);

            case STREET_ADDRESS_SET_VALUE:
                error = validateAlphaNumericString(action.value, { subject: 'Street Address', required: false });
                return setStreetAddressValid(error);

            case BUILDING_SET_VALUE:
                error = validateAlphaNumericString(action.value, { subject: 'Building', required: false });
                return setBuildingValid(error);

            case REFERRED_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Referred By',
                });
                return setReferredValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
